import { Prefill } from '@library/formBuilder/prefill';
import type { AtomModel } from '@models/atom.model';
import type { DateFieldData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<DateFieldData>;
};

export const DateModal = ({ atom }: Props) => (
  <>
    <Prefill atom={atom} />
  </>
);
